import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { LANGUAGE_URL } from '../../../vars'

/**
 * @namespace Language
 * @description Язык 
 */
export default {
    state: {
        appLanguage: localStorage.getItem("language") || process.env.VUE_APP_I18N_LOCALE || 'ru',
    },
    mutations: {
        SET_APP_LANGUAGE(state, language) {
        
            state.appLanguage = language;
            localStorage.setItem("language", language); // Whenever we change the appLanguage we save it to the localStorage
        },
    },
    actions: {
       /**
        * Сменяет язык системы
        * @param {Object} ctx 
        * @param {Object} data Объект с данными (id, language) 
        * @throws Ошибка запроса данных
        * 
        * @memberof Language
        */
       async LANGUAGE_SWITCH(ctx, data) {

            try {
                const res = await axios.patch(LANGUAGE_URL, data, {headers: {
                    Authorization: `Token ${localStorage.token}`,
                }});

                await ctx.commit('SET_APP_LANGUAGE', res.data.language)
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
       }
    },
    getters: {
        GETTERS_APP_LANGUAGE_NTRANSLATE(state) {
            return state.appLanguage
        },
        GETTERS_APP_LANGUAGE(state) {
            if (state.appLanguage === 'ru') return 'EN'
            else  return 'RU'
        },
    }
}